module.exports = "images/doc-country-add.ac707bcbe2643b58474e7a1ff43358f6.png";